module.exports = __webpack_public_path__ + "img/上海凌力.6e423c7b.jpg";